import type { SubscriptionPrice, CreateSubscriptionPriceData } from '@/types/subscriptionTypes';
import { supabase } from '@/lib/supabase';

export const SubscriptionPriceService = {
  /**
   * Get subscription prices for an organization
   */
  async getPricesForOrganization(organizationId: string): Promise<SubscriptionPrice[]> {
    try {
      // Mock subscription prices for now - replace with real API call when database is set up
      return [
        {
          id: 'price_essential_monthly',
          organization_id: organizationId,
          name: 'Essential',
          description: 'Powerful features to run your business like a pro',
          amount_cents: 4900,
          billing_period: 'monthly',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          is_active: true,
          stripe_price_id: 'price_essential_monthly',
          stripe_product_id: 'prod_essential',
          trial_period_days: 14,
          currency: 'usd',
          interval_count: 1,
          metadata: null,
          features: [
            'Unlimited students, staff & locations',
            'Ask AI Expert',
            'Parent portal',
            'Class booking & management',
            'Payment services',
            'Online waiver & policy management',
            'Electronic signature & audit tracking',
            'Website integration',
            'eCommerce',
            'In-app 2-way messaging'
          ],
          slug: 'essential_monthly',
        },
        {
          id: 'price_advanced_monthly',
          organization_id: organizationId,
          name: 'Advanced',
          description: 'Expanded capabilities for scaling your business',
          amount_cents: 9900,
          billing_period: 'monthly',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          is_active: true,
          stripe_price_id: 'price_advanced_monthly',
          stripe_product_id: 'prod_advanced',
          trial_period_days: 14,
          currency: 'usd',
          interval_count: 1,
          metadata: null,
          features: [
            'Everything in Essential, plus:',
            'Expanded electronic document volume',
            'Form Designer',
            'Hive360, integrates enrollment right on your website',
            'Expanded Ask AI Expert usage'
          ],
          slug: 'hivetivity-advanced',
        },
        {
          id: 'price_enterprise_monthly',
          organization_id: organizationId,
          name: 'Enterprise',
          description: 'The sky is the limit with unlimited everything & personalized support',
          amount_cents: 19900,
          billing_period: 'monthly',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          is_active: true,
          stripe_price_id: 'price_enterprise_monthly',
          stripe_product_id: 'prod_enterprise',
          trial_period_days: 14,
          currency: 'usd',
          interval_count: 1,
          metadata: null,
          features: [
            'Everything in Advanced, plus:',
            'Unlimited electronic document volume',
            'Unlimited Ask AI Expert Usage',
            'White-glove, personalized onboarding',
            'Concierge customer support'
          ],
          slug: 'enterprise_monthly',
        }
      ];
    } catch (error) {
      console.error('Error fetching subscription prices:', error);
      return [];
    }
  },
  async createPrice(plan: CreateSubscriptionPriceData): Promise<SubscriptionPrice> {
    const { data, error } = await supabase.functions.invoke('create-subscription-price', {
      body: plan,
    });
    if (error) throw error;
    return data as SubscriptionPrice;
  },
  async archivePrice(id: string): Promise<void> {
    const { error } = await supabase.functions.invoke('archive-subscription-price', {
      body: { id },
    });
    if (error) throw error;
  }
}; 